import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-auth-required',
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  templateUrl: './auth-required.component.html',
  styleUrls: ['./auth-required.component.css']
})
export class AuthRequiredComponent {
  message = 'Please authenticate in Comtrak, then return to Comforce.';
  busy = false;

  constructor(private router: Router, private auth: AuthService) {}

  goToComtrak(): void {
    window.location.href = environment.comtrakURL;
  }

  async tryAgain(): Promise<void> {
    this.busy = true;
    const ok = await this.auth.validateWithExternalLogin();
    this.busy = false;
    if (ok) {
      this.router.navigateByUrl('/home');
    }
  }
}


